
//审核
import Audit from '@/view/Audit/Audit.vue';
import AuditCPI from '@/view/Audit/AuditCPI.vue';
import AuditDSP from '@/view/Audit/AuditDSP.vue';

//全局数据
import DataAnalysis from '@/view/DataAnalysis/DataAnalysis.vue';
import AccountAnalysis from '@/view/DataAnalysis/AccountAnalysis.vue';
import CountryAnalysis from '@/view/DataAnalysis/CountryAnalysis.vue';
import BundleAnalysis from '@/view/DataAnalysis/BundleAnalysis.vue';
import AdsenseAnalysis from '@/view/DataAnalysis/AdsenseAnalysis.vue';

//算法
import Algorithm from '@/view/Algorithm/Algorithm.vue';
import AlgorithmData from '@/view/Algorithm/Data.vue';
import AlgorithmConfig from '@/view/Algorithm/Config.vue';

// 全局广告维护 不得不同时维护两份一摸一样的代码fuck
import PromotionManagement from '@/view/PromotionManagement/PromotionManagement.vue'
import AdvSeries from '@/view/PromotionManagement/Series.vue'
import AdvGroup from '@/view/PromotionManagement/Campaign.vue'
import AdvItem from '@/view/PromotionManagement/Creative.vue'
import newPromition from '@/view/NewPromotion/NewPromotion.vue'

//打款管理
import Payment from '@/view/Payment/PaymentRecord.vue'
import PmtSeries from '@/view/Payment/Series.vue'
import PmtBalance from '@/view/Payment/Balance.vue'

//操作记录
import recordHistory from '@/view/record/history.vue'
import recordithm from '@/view/record/Algorithm.vue';

export default [
    {
        path: '*',
        redirect: '/audit/dsp',
    },
    {
        path: '/audit',
        name: 'audit',
        meta: {
            menu: '审核创意',
            sub: true,
            key: '1',
        },
        component: Audit,
        children: [
            {
                path: 'dsp',
                name: 'auditDSP',
                meta: {
                    menu: 'DSP创意审核',
                    key: '101',
                },
                component: AuditDSP,
            },
            {
                path: 'cpi',
                name: 'auditCPI',
                meta: {
                    menu: 'CPI创意审核',
                    key: '102',
                },
                component: AuditCPI,
            },
        ],
    },
    {
        path: '/dataAnalysis',
        name: 'dataAnalysis',
        component: DataAnalysis,
        meta: {
            menu: '全局数据',
            sub: true,
            key: '2',
        },
        children: [
            {
                path: 'account',
                name: 'accountAnalysis',
                component: AccountAnalysis,
                meta: {
                    menu: '账号',
                    key: '201',
                },
            },
            {
                path: 'country',
                name: 'countryAnalysis',
                component: CountryAnalysis,
                meta: {
                    menu: '国家',
                    key: '202',
                },
            },
            {
                path: 'bundle',
                name: 'bundleAnalysis',
                component: BundleAnalysis,
                meta: {
                    menu: '包名',
                    key: '203',
                },
            },
            {
                path: 'adsense',
                name: 'adsenseAnalysis',
                component: AdsenseAnalysis,
                meta: {
                    menu: '广告位',
                    key: '204',
                },
            },
            {
                path: '/',
                redirect: 'account',
            },
        ],
    },
    // {
    //     path: '/algorithm',
    //     name: 'algorithm',
    //     meta: {
    //         menu: '算法管理',
    //         sub: true,
    //         key: '3',
    //     },
    //     component: Algorithm,
    //     children: [
    //         {
    //             path: 'data',
    //             name: 'algorithmData',
    //             meta: {
    //                 menu: '算法数据',
    //                 key: '301',
    //             },
    //             component: AlgorithmData,
    //         },
    //         {
    //             path: 'config',
    //             name: 'algorithmConfig',
    //             meta: {
    //                 menu: '算法配置',
    //                 key: '302',
    //             },
    //             component: AlgorithmConfig,
    //         },
    //     ],
    // },
    {
        path: '/adv',
        name: 'adv',
        meta: {
            menu: '广告管理',
            sub: true,
            key: '4'
        },
        component: PromotionManagement,
        children: [
            {
                path: 'series',
                name: 'adv-series',
                meta: {
                    menu: '广告系列',
                    key: '401',
                },
                component: AdvSeries,
            },
            {
                path: 'group',
                name: 'adv-group',
                meta: {
                    menu: '广告组',
                    key: '402',
                },
                component: AdvGroup,
            },
            {
                path: 'item',
                name: 'adv-item',
                meta: {
                    menu: '广告',
                    key: '403',
                },
                component: AdvItem,
            },
            {
                path: '/',
                redirect: 'series',
            },
        ]
    },
    {
        path: '/record',
        name: 'record',
        meta: {
            menu: '操作记录',
            sub: true,
            key: '5'
        },
        component: recordithm,
        children: [
            {
                path: 'history',
                name: 'history',
                meta: {
                    menu: '操作记录',
                    key: '501',
                },
                component: recordHistory,
            },
            {
                path: '/',
                redirect: 'history',
            },
        ]
    },
    {
        path: '/pmt',
        name: 'pmt',
        meta: {
            menu: '打款管理',
            sub: true,
            key: '6'
        },
        component: Payment,
        children: [
            {
                path: 'series',
                name: 'pmt-series',
                meta: {
                    menu: '打款记录',
                    key: '601',
                },
                component: PmtSeries,
            },
            {
                path: 'balance',
                name: 'pmt-balance',
                meta: {
                    menu: '账号余额',
                    key: '602',
                },
                component: PmtBalance,
            },
            {
                path: '/',
                redirect: 'series',
            },
        ]
    },
    {
        path: '/newPromition',
        name: 'newPromition',
        meta: {
            key: '4'
        },
        component: newPromition,
    }
];



// WEBPACK FOOTER //
// ./src/router/routes.js